import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class BlockHistory {
	static init() {
		this.blocks = document.querySelectorAll(".block-history");
		this.blocks.forEach( block => {

			let container = block.querySelector('.block-history-detail');
			let inner = block.querySelector('.inner');
			let background = block.querySelector('.mask');
			let gradient = block.querySelector('.gradient');

			let mm = gsap.matchMedia();

			mm.add("(min-width: 992px)", () => {

				ScrollTrigger.create({
					trigger: container,
					start: 'top top',
					end: 'bottom bottom',
					pin: background,
					toggleClass: {
						targets: ".mask",
						className: "active"
					}
				});

				ScrollTrigger.create({
					trigger: container,
					start: 'top top',
					end: 'bottom bottom',
					pin: gradient
				});

				const itemYears = block.querySelectorAll('.item-year');
				this.ladderYears = block.querySelectorAll('.ladder-year');
				this.yearHighlight = block.querySelector('.year-highlight');

				this.currentYear = block.querySelector('.ladder-year.current').dataset.year;
				this.changeDate();

				itemYears.forEach( item => {
					ScrollTrigger.create({
						trigger: item,
						start: 'top center',
						end: 'bottom center',
						onEnter: () => {
							this.currentYear = item.dataset.year;
							this.laddeYear();
							this.changeDate();
						},
						onEnterBack: () => {
							this.currentYear = item.dataset.year;
							this.laddeYear();
							this.changeDate();
						}
					});
				});

				this.ladderYears.forEach( y => {
					y.addEventListener('click', () => {
						const target = block.querySelector('.item-year[data-year="'+ y.dataset.year +'"]');
						const offset = parseInt(window.getComputedStyle(inner).marginTop) + parseInt(window.getComputedStyle(target).paddingBottom);
						GlobalVariables.lenis.scrollTo(target, {
							duration: 1,
							offset: offset
						});
					});
				});

			});

		});
	}

	static laddeYear(){
		this.ladderYears.forEach( y => {
			y.classList.toggle('current', this.currentYear === y.dataset.year );
		});
	}

	static changeDate(){

		const translateArray = [];
		translateArray[9] = 0;
		translateArray[0] = 100;
		translateArray[3] = 200;
		translateArray[1] = 300;
		translateArray[4] = 400;
		translateArray[5] = 500;
		translateArray[2] = 600;
		translateArray[6] = 700;
		translateArray[8] = 800;
		translateArray[7] = 900;

		const centuryTen = this.yearHighlight.querySelector(".centuries .ten");
		const centuryUnit = this.yearHighlight.querySelector(".centuries .unit");
		const decadTen = this.yearHighlight.querySelector(".decads .ten");
		const decadUnit = this.yearHighlight.querySelector(".decads .unit");
		const currentDate = this.currentYear.split('');

		gsap.to(centuryTen,{
			yPercent : "-" + translateArray[ currentDate[0] ],
			duration: 1.5,
			ease: "power3.out"
		});
		gsap.to(centuryUnit,{
			yPercent : "-" + translateArray[ currentDate[1] ],
			duration: 1.5,
			ease: "power3.out"
		});
		gsap.to(decadTen,{
			yPercent : "-" + translateArray[ currentDate[2] ],
			duration: 1.5,
			ease: "power3.out"
		});
		gsap.to(decadUnit,{
			yPercent : "-" + translateArray[ currentDate[3] ],
			duration: 1.5,
			ease: "power3.out"
		});
	}

}
